// Old borwser support for VueX
// import 'es6-promise/auto'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store/store'

import $ from 'jquery'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuex)

new Vue({
  store,
  router,
  render: h => h(App),
  data: {
    products: [],
    isLoading: false,
    axiosInterceptor: null,
  },

  mounted() {
    if(localStorage.getItem('products')) {
      try {
        this.products = JSON.parse(localStorage.getItem('products'));
      } catch(e) {
        localStorage.removeItem('products');
      }
    }

    this.$on('save-product', data => {
      // Add the product with the answers to the array
      this.$data.products.push({
        id      : data.product,
        answers : data.answers
      });
      localStorage.setItem('products', JSON.stringify(this.$data.products));
    });
  }
}).$mount('#app')


$( document ).ready(function() {

  $( "a" ).click(function( event ) {
    event.preventDefault();
  });

});